import React, { Component } from 'react'
import { Link, Redirect } from 'react-router-dom';
import HeaderMain from './HeaderMain';
import FooterMain from './FooterMain';

class Movers extends Component {
    state = {}

    componentDidMount() { 
        window.$(window).on("load", function () {
            /* Page Scroll to id fn call */
            window.$("#provider-grid a,a[href='#top'],a[rel='m_PageScroll2id']").mPageScroll2id({
                highlightSelector: "#provider-grid a"
            });

            /* demo functions */
            window.$("a[rel='next']").click(function (e) {
                e.preventDefault();
                var to = window.$(this).parent().parent("section").next().attr("id");
                window.$.mPageScroll2id("scrollTo", to);
            });
        });
        
    }

    render() {
        return (
            <div>
                 <HeaderMain />
                 <div className="movers-banner">
    <div className="container">
        <div className="row">                
            <div className="col-sm-6">
                <div className="movers-banner-content">
                    <h1 className="m-0 common-banner-title">
                        Technology built for Drivers
                        revolutionizes your Moving
                        Company!
                    </h1>
                    <p className="m-0 common-banner-title-pera">
                        Save $$, Retain Drivers, Increase Customer Satisfaction,
                        Reduce Claims by 90% and so much more!
                    </p>
                </div>
            </div>
        </div>
    </div>
</div>

<div className="movers-sec1 bg-red p-t-30 p-b-30">
    <div className="container">
        <div className="row">
            <div className="col-md-4">
                <div className="movers-sec1-grid">
                    <div className="media">
                        <div className="media-left">
                            <i><img src="assets/images/icons/white/broken-link.svg" width="50"/></i>
                        </div>
                        <div className="media-body p-l-5 p-r-20">
                            <h5 className="m-0 p-b-5">
                                Connect with Drivers,
                                Helpers and Customers
                            </h5>
                            <p className="m-0">Our secure chat allows you to stay
                                connected with everybody involved 
                                in the move.</p>
                        </div>
                    </div>
                </div>
            </div>
            <div className="col-md-4">
                <div className="movers-sec1-grid">
                    <div className="media">
                        <div className="media-left">
                            <i><img src="assets/images/icons/white/dollar-coins.svg" width="50"/></i>
                        </div>
                        <div className="media-body p-l-5 p-r-20">
                            <h5 className="m-0 p-b-5">
                                More Profits, Save $$
                            </h5>
                            <p className="m-0 p-b-10">Help save $$ on Hotels, Fuel,
                                Packing Material, Truck Rentals,
                                Moving Equipment, & 1,000's of
                                other Products and Services.&nbsp;<br/>
                                <span className="f-s-15 text-medium">$GET HUGE DISCOUNTS$</span>
                            </p>
                        </div>
                    </div>
                </div>
            </div>
            <div className="col-md-4">
                <div className="movers-sec1-grid">
                    <div className="media">
                        <div className="media-left">
                            <i><img src="assets/images/icons/white/group.svg" width="50"/></i>
                        </div>
                        <div className="media-body p-l-5 p-r-20">
                            <h5 className="m-0 p-b-5">
                                Add efficiency and lower
                                claims
                            </h5>
                            <p className="m-0 p-b-10">Send jobs directly to ReloDrivers and
                                ReloHelpers from any device.
                                Our CYA (Cover-Your-@ss) feature saves
                                everyone $$ and ensures lower claim
                                costs.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div className="movers-sec2 p-t-60 p-b-40">
    <div className="container">
        <div className="row">
            <div className="col-md-12">
                <h2 className="m-0 m-b-15 f-s-35 text-semi-bold">Why ReloDriver?</h2>
                <p>Our platform was built to make professional Drivers' jobs EASIER and MORE Profitable.
                    This helps Movers, like you, retain and build their teams by giving them cutting edge tools,
                    that make moving STRESS FREE & EASY.</p>
                <p>Our ReloDrivers make MORE $$, save MORE $$, and show customers what professionals can do when given tools to get the job done RIGHT!</p>

            </div>

            <div className="movers-sec2-grid-wrap text-center">
                <div className="movers-sec2-grid">
                    <i><img src="assets/images/icons/blue/padlock.svg" width="40"/></i>
                    <h5>Saving $$ = Financial Security</h5>
                    <p>Huge discounts on Hotels, Fuel,
                        Packing Materials, Truck Rentals, Bookkeeping
                        and tons of other products and services 
                        which lead to financial security for every one.</p>
                </div>
                <div className="movers-sec2-grid">
                    <i><img src="assets/images/icons/blue/suitcase.svg" width="40"/></i>
                    <h5>Got a Job?</h5>
                    <p>Our ReloDriver allows your drivers to check ReloDrivers' & ReloHelpers'
                        availability, assign jobs, update job
                        information, and so much more.</p>
                </div>
                <div className="movers-sec2-grid">
                    <i><img src="assets/images/icons/blue/search.svg" width="40"/></i>
                    <h5>Find Pro's who can Help</h5>
                    <p>Access our database of over 1,000 
                        Professional ReloHelpers and get 
                        the job done right.</p>
                </div>
                <div className="movers-sec2-grid">
                    <i><img src="assets/images/icons/blue/smile.svg" width="40"/></i>
                    <h5>Happy Driver = Satisfied Customer<br/>
                        = More Profits</h5>
                    <p>Our features ensure the highest level of 
                        retention of Drivers, by supplying easy-to-use 
                        tools, which <span>increase</span> Revenue, Lower 
                        Cost, and lead to satisfied customers.
                    </p>
                </div>
                <div className="movers-sec2-grid">
                    <i><img src="assets/images/icons/blue/settings.svg" width="40"/></i>
                    <h5>Accountability and CYA</h5>
                    <p>Our revolutionary CYA (Cover-Your-@ss) 
                        feature dramatically lowers claim 
                        costs, with our easy to use ReloDriver app.</p>
                </div>
                <div className="movers-sec2-grid">
                    <i><img src="assets/images/icons/blue/track.svg" width="40"/></i>
                    <h5>Where's My Driver?</h5>
                    <p>Real time tracking of Drivers
                        and Helpers to ensure &nbsp;
                        <img src="assets/images/icons/smiling.svg" width="20"/>&nbsp; Customers.</p>
                </div>
            </div>

        </div>
    </div>
</div>

<section className="movers-sec3 p-t-60 p-b-60">
    <div className="container">
        <div className="row">
            <div className="col-md-12 text-center text-white">
                <h2 className="m-0 m-b-15 f-s-25 text-semi-bold">HELP YOUR TEAM BY CONNECTING TO THE LARGEST NETWORK OF<br/>
                    TOOLS BUILT BY AND FOR PROFESSIONAL DRIVERS.</h2>
                <p>We GUARANTEE our app will SAVE you $$.<br/> Professionals require the right tools to get the job done.<br/> 
                    Give your drivers the best app to SAVE $$, MAKE $$, and INCREASE Customer Satisfaction.</p>
                <div className="number m-t-40 m-b-40">
                    4525
                </div>
                <p className="m-0 p-b-30">Users, Products and Services on Our Network.</p>
                <a  href="#" className="page-btn bg-red">BECOME A MEMBER NOW (It's FREE!)</a>
            </div>
        </div>
    </div>
</section>

<section className="subscription-wrap text-center">
    <div className="subscription-overlay p-t-40 p-b-60">
        <div className="container">
            <div className="row">
                <div className="col-md-12 p-b-40">
                    <h2 className="m-0 text-center common-title f-s-35 text-semi-bold">Subscription Plans</h2>
                </div>

                <div className="col-md-4 col-sm-6 col-md-offset-2">
                    <div className="pricing text-center">
                        <div className="pricing-header bg-gradient-blue">
                            <h6 className="pricing-title m-0">Free Membership</h6>
                        </div>
                        <div className="pricing-body">
                            <div className="pricing-price text-blue p-t-20">
                                FREE
                            </div>
                            <ul className="pricing-list">
                                <li>Search our database of :<br/>
                                    1,000+ Pro ReloHelpers<br/>
                                    1,000+ ReloDrivers<br/>
                                    2,500+ Moving Companies.
                                </li>
                                <li><span className="f-s-18 text-blue-800">Make More $$</span><br/> Post your availability to do side jobs while awaiting your next shipment.</li>
                                <li>
                                <span className="f-s-18 text-success">Save $$$</span><br/>Truck Rental, Packing Material, Hotels, Fuel, Moving Equipment, Bookkeeping, and many other products and services that you need to get the job done right!
                                </li>
                                <li>Find Truck Parking.</li>
                                <li>Manage your Schedule</li>
                                <li>Roadside Service.</li>                                
                            </ul>
                        </div>
                        <div className="pricing-footer p-t-20 p-b-20">
                            <a href="#" className="pricing-footer-bg-blue">Select</a>
                        </div>
                    </div>
                </div>

                <div className="col-md-4 col-sm-6">
                    <div className="pricing text-center">
                        <div className="pricing-header bg-gradient-green">
                            <p>popular</p>
                            <h5 className="pricing-title m-0">Pro</h5>
                            <div className="offer">
                                <span>50%</span>
                                <b>OFF</b>
                            </div>
                        </div>
                        <div className="pricing-body">
                            <div className="pricing-price text-green p-t-20">
                                <span className="pricing-currency">$</span> 15 <span>/mo.per Driver</span>
                                <p>All benefits of free membership</p>
                                <i><img src="assets/images/icons/green/add.svg" width="20"/></i>
                            </div>
                            <ul className="pricing-list">
                                <li>
                                    Reduce claims by 90% with CYA feature.<br/>
                                    (Cover-Your-@ss)
                                </li>
                                <li>Find More Loads<br/>
                                    (Help your dispatchers keep your driver rolling,
                                    with our list of 100's of MORE shipments)</li>
                                <li>Chat with Movers, ReloHelpers,
                                    Customers and all other ReloMembers.
                                </li>
                                <li>Get Paid faster, Pay Helpers, Get Tips from Customer<br/>
                                    <span className="text-success">(Coming Soon)</span>
                                </li>
                            </ul>
                        </div>
                        <div className="pricing-footer p-t-20 p-b-20">
                            <a href="#" className="pricing-footer-bg-green">Select</a>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>
</section>
<FooterMain />
</div>
        );
    }
}

export default Movers;